import { Link } from "react-router-dom";
import { Icon, RenderWhen } from "../../../../../../components";
import RLCard from "../../../../../../components/card/RLCard";
import { usePagination } from "../../../../../../hooks";
import { COMPONENT_IDS, SECTIONS } from "../../../../consts";
import { useLocalSampleSummaryParams } from "../../../../hooks";
import { pathToSS } from "../../../../util";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import useNetworkReferences from "../../hooks/useNetworkReferences";
import { Tooltip } from "../common";
import NetworkReferencesGrid from "./NetworkReferencesGrid";

import { formatCount } from "../../../../../../components/PageResultsCount";
import styles from "./network-references.module.scss";

const NetworkReferencesCard = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();

  const {
    data: networRefsData,
    stats: networkStats,
    dataReady: isNetworkRefFetched
  } = useNetworkReferences();

  const { data: networkRefDataTop5 } = usePagination(networRefsData, {
    pageSize: 5
  });

  return (
    <RLCard
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              placement="top"
              message={
                <div>
                  <span>{DESCRIPTIONS[COMPONENT_IDS.NETWORK_REFERENCES]}</span>
                  <br />
                  <span>
                    Number of unique references:{" "}
                    {formatCount(networkStats.total)}. Analysis based on the
                    first {formatCount(networRefsData.length)} network
                    references.
                  </span>
                </div>
              }
            >
              <div className="flex align-center flex-gap-2">
                <span>
                  {`Network References (${formatCount(networkStats.total)})`}
                </span>
                <RenderWhen condition={networkStats.hasMoreData}>
                  <Icon name="warning-i" style={{ color: "orange" }} />
                </RenderWhen>
              </div>
            </Tooltip>
          }
          LinkComponent={
            <Link
              className={styles.link}
              to={pathToSS(
                hash,
                sourceId,
                SECTIONS.FILE_ANALYSIS.NETWORK_REFERENCES,
                relationshipId
              )}
              data-testid="report_summary_network_references_see_all_link"
            >
              See All Network References
            </Link>
          }
        />
      }
      content={
        <RLCard.Content data-testid="report_summary_network_references_grid">
          <NetworkReferencesGrid
            data={networkRefDataTop5}
            sourceId={sourceId}
            relationshipId={relationshipId}
            isLoading={!isNetworkRefFetched}
            hidePaging
          />
        </RLCard.Content>
      }
      data-testid="report_summary_network_references_card"
    />
  );
};
export default NetworkReferencesCard;
